if (!customElements.get('togglerFacets')) {
  customElements.define(
    'toggler-facets',
    class togglerFacets extends HTMLElement {
      constructor() {
        super();

        this.facetsWrapper = document.querySelector('.facets-vertical');
        this.addEventListener('click', this.toggleFacets.bind(this));
      }

      toggleFacets(event) {
        event.preventDefault();
        this.facetsWrapper.classList.toggle('facets--hide');
        const gridProduct = document.querySelector('#product-grid');
        gridProduct.classList.toggle('adapte-grid-product');
      }
    }
  );
}
